export const ENTITY = 'appnexus-audiences'

export const TABLE_COLUMNS_SINGULAR = [
  {
    name: 'Is Inherited',
    key: 'isInherited',
    width: 120,
  },
  {
    name: 'Inherited From Provider Element Id',
    key: 'inheritedFromProviderElementId',
    link: `/${ENTITY}/:inheritedFromProviderElementId`,
    styles: { textAlign: 'left' },
  },
  {
    name: 'Rate Level',
    key: 'rateLevel',
    width: 150,
  },
  {
    name: 'Partner Id',
    key: 'partnerId',
    width: 120,
  },
  {
    name: 'Rate Type',
    key: 'rateType',
    width: 120,
  },
  {
    name: 'CPMRate',
    key: 'cPMRate.amount',
    width: 120,
  },
  {
    name: 'Percent Of Media Cost Rate',
    key: 'percentOfMediaCostRate',
    width: 200,
  },
]
